export enum districtBoardTestIds {
  DISTRICT_BOARD = "district-board",
  DISTRICT_BOARD_HEADER = "district-board-header",
  DISTRICT_BOARD_NAME = "district-board-name",
  DISTRICT_BOARD_LOCATION = "district-board-location",
  DISTRICT_BOARD_SHARE_BUTTON = "district-board-share-button",
  DISTRICT_BOARD_STATS = "district-board-stats",
  DISTRICT_BOARD_STAT_SCHOOLS = "district-board-stat-schools",
  DISTRICT_BOARD_STAT_STUDENTS = "district-board-stat-students",
}

export enum districtBoardTabsTestIds {
  DISTRICT_BOARD_TABS = "district-board-tabs",
  DISTRICT_BOARD_TAB_OPEN_POSITIONS = "district-board-tab-open-positions",
  DISTRICT_BOARD_TAB_NON_TEACHING = "district-board-tab-non-teaching",
}

export enum districtBoardViewToggleTestIds {
  DISTRICT_BOARD_VIEW_TOGGLE = "district-board-view-toggle",
  DISTRICT_BOARD_VIEW_BY_SCHOOL = "district-board-view-by-school",
  DISTRICT_BOARD_VIEW_BY_JOB = "district-board-view-by-job",
}

export enum districtBoardResultsTestIds {
  DISTRICT_BOARD_RESULTS_SUMMARY = "district-board-results-summary",
  DISTRICT_BOARD_SCHOOL_GROUP = "district-board-school-group",
  DISTRICT_BOARD_JOBS_EMPTY = "district-board-jobs-empty",
  DISTRICT_BOARD_PAGE_EMPTY = "district-board-page-empty",
  DISTRICT_BOARD_SCHOOLS_EMPTY = "district-board-schools-empty",
  DISTRICT_BOARD_BY_JOB_EMPTY = "district-board-by-job-empty",
  DISTRICT_BOARD_NON_TEACHING_LIST = "district-board-non-teaching-list",
  DISTRICT_BOARD_NON_TEACHING_JOB = "district-board-non-teaching-job",
  DISTRICT_BOARD_NON_TEACHING_EMPTY = "district-board-non-teaching-empty",
}

export enum districtBoardPaginationTestIds {
  PREV_BUTTON = "district-board-pagination-prev",
  NEXT_BUTTON = "district-board-pagination-next",
}

export enum districtBoardFiltersTestIds {
  DISTRICT_BOARD_FILTERS_PANEL = "district-board-filters-panel",
  DISTRICT_BOARD_FILTERS_SEARCH = "district-board-filters-search",
  DISTRICT_BOARD_FILTERS_SCHOOL = "district-board-filters-school",
  DISTRICT_BOARD_FILTERS_SUBJECT = "district-board-filters-subject",
  DISTRICT_BOARD_FILTERS_GRADE = "district-board-filters-grade",
  DISTRICT_BOARD_FILTERS_NON_TEACHING_PANEL = "district-board-filters-non-teaching-panel",
  DISTRICT_BOARD_FILTERS_JOB_TYPE = "district-board-filters-job-type",
  DISTRICT_BOARD_FILTERS_EMPLOYMENT_TYPE = "district-board-filters-employment-type",
  DISTRICT_BOARD_MOBILE_FILTERS_BAR = "district-board-mobile-filters-bar",
  DISTRICT_BOARD_MOBILE_FILTERS_BUTTON = "district-board-mobile-filters-button",
}

export enum districtJobDetailsTestIds {
  DISTRICT_JOB_PANEL = "district-job-panel",
  DISTRICT_JOB_PANEL_NAME = "district-job-panel-name",
  DISTRICT_JOB_PANEL_LOCATION = "district-job-panel-location",
  DISTRICT_JOB_HEADER_DISTRICT_NAME = "district-job-header-district-name",
}
